import styled from "styled-components";

/** Título do popover de escolha do tipo de ordem de coleta. */
export const TituloPopover = styled.span`
    font-size: 13px;
    font-weight: 600;
    color: var(--text-color);
`
